import type { PropsWithChildren } from "react";

import { icons } from "~/ui";

export const FieldHint = ({ children }: PropsWithChildren) => (
  <p className="text-footer-text flex items-start gap-1 pt-1 text-sm">
    <icons.outline.InformationCircleIcon className="size-5 shrink-0" />
    {children}
  </p>
);
